export default __webpack_public_path__ + "static/billie-be48f153277773430754caadea2e7b57.jpeg";